import { format, isValid, parse } from "date-fns";
import { GET, POST, POSTMEDIA, PUT } from "../shared/utils/crud";

const toApiDate = (value) => {
  if (!value) return "";
  const parsed = parse(value, "dd/MM/yyyy", new Date());
  if (!isValid(parsed)) return "";
  return format(parsed, "yyyy-MM-dd");
};

const consultaGrupo = async (idGrupo) => {
  const res = await GET(`consulta-grupo?grupo=${idGrupo}`);
  return res;
};

const URL_DESCARGA_COTIZADOR = process.env.REACT_APP_URL_DESCARGA_COTIZADOR;

const descargarCotizador = async ({ grupo }) => {
  if (!URL_DESCARGA_COTIZADOR) {
    return {
      data: null,
      error: "No está configurada la URL de descarga del cotizador",
    };
  }
  try {
    const extension =
      URL_DESCARGA_COTIZADOR.split('?')[0].match(/\.(xlsx|xlsm)$/i)?.[1] ||
      'xlsx';
    const a = document.createElement('a');
    a.setAttribute('href', URL_DESCARGA_COTIZADOR);
    a.setAttribute('download', `cotizador-${grupo}.${extension}`);
    a.click();
    return { data: { ok: true }, error: null };
  } catch (error) {
    return {
      data: null,
      error: "No se pudo conectar con el servicio de descarga",
    };
  }
};

const uploadFleetXlsx = async ({
  idGrupo,
  file,
  usuario,
  noSolicitud,
  inicioVigencia,
}) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("usuario", usuario);
  const params = [];
  if (noSolicitud) params.push(`noSolicitud=${noSolicitud}`);
  const fechaApi = toApiDate(inicioVigencia);
  if (fechaApi) params.push(`inicioVigencia=${fechaApi}`);
  const query = params.length ? `?${params.join("&")}` : "";
  const res = await POSTMEDIA(
    `endoso/upload-fleet-xlsx/${idGrupo}${query}`,
    formData
  );
  if (res.data?.codigo === 1) return { data: res.data, error: null };
  return { data: null, error: res.error || res.data };
};

const listaSoflosub = async ({ usuario }) => {
  const res = await GET(`endoso/lista-soflosub?usuario=${usuario}`);
  if (res.data?.codigo === 1 && Array.isArray(res.data?.solicitudes)) {
    return { data: res.data.solicitudes, error: null };
  }
  return { data: null, error: res.error || res.data };
};

const getFleetQuoteDetail = async ({ requestNumber }) => {
  const res = await GET(`fleet-quote/${requestNumber}`);
  if (res.data?.codigo === 1) return { data: res.data, error: null };
  return { data: null, error: res.error || res.data };
};

const createFleetQuote = async ({ requestNumber, username, email, name }) => {
  const res = await POST("fleet-quote", {
    requestNumber,
    username,
    email,
    name,
  });
  if (res.data?.codigo === 1) return { data: res.data, error: null };
  return { data: null, error: res.error || res.data };
};

const getGroupFleetProducts = async ({ requestNumber }) => {
  const res = await GET(`group-fleet/products?requestNumber=${requestNumber}`);
  if (res.data?.codigo === 1 && Array.isArray(res.data?.data?.products)) {
    return { data: res.data.data.products, error: null };
  }
  return { data: null, error: res.error || res.data };
};

const emitFleet = async (payload) => {
  const res = await POST("fleet-issuance", payload);
  if (res.data?.codigo === 1) return { data: res.data, error: null };
  return { data: null, error: res.error || res.data };
};

const cancelaSoflosub = async ({ noSolicitud }) => {
  const res = await PUT("endoso/cancela-soflosub", { noSolicitud });
  if (res.data?.codigo === 1) return { data: res.data, error: null };
  return { data: null, error: res.error || res.data };
};

const cotizador = {
  consultaGrupo: consultaGrupo,
  descargarCotizador: descargarCotizador,
  uploadFleetXlsx: uploadFleetXlsx,
  listaSoflosub: listaSoflosub,
  getFleetQuoteDetail: getFleetQuoteDetail,
  createFleetQuote: createFleetQuote,
  getGroupFleetProducts: getGroupFleetProducts,
  emitFleet: emitFleet,
  cancelaSoflosub: cancelaSoflosub,
};

export default cotizador;
